import { createFileRoute } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";

// The root path redirects to the visitor's role landing page or sign-in.
export const Route = createFileRoute("/")({
  beforeLoad: ({ location }) =>
    applyAuthGuard(location.pathname, new URLSearchParams(location.searchStr)),
});
